module.exports = __webpack_public_path__ + "1a7eeaf5d123845bbeb95427d502582b.png";